import { RouterProvider } from 'react-router-dom';
import { SesionProvider } from './estado/SesionContext';
import { router } from './router';

export default function App() {
  return (
    <SesionProvider>
      <RouterProvider router={router} />
    </SesionProvider>
  );
}
